import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../themed/button';
import Form from '../../common/form';

class VIObservationItemForm extends Form {
	state = {
		data: { observation: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onAddObservation: PropTypes.func.isRequired,
	};

	schema = {
		observation: Joi.string().min(10).required().label('Observation'),
	};

	handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.code === 'Enter') {
			event.preventDefault();
			this.doSubmit();
		}
	};

	doSubmit = () => {
		const errors: any = this.validate();
		if (errors) {
			this.setState({ errors: errors || {} }, this.handleFormErrorNotice);
		} else {
			this.props.onAddObservation(this.state.data.observation);
			this.setState({ data: { ...this.state.data, observation: '' } });
		}
	};

	render() {
		return (
			<div className="row">
				<div className="col-9">
					{this.renderInput({
						type: 'text',
						name: 'observation',
						placeholder: 'Enter Observation / Result',
						label: 'Observation / Result',
						onKeyDown: this.handleKeyPress,
					})}
				</div>

				<div className="col">
					<Button label="" icon="plus" type="button" onClick={this.doSubmit} />
				</div>
			</div>
		);
	}
}

export default VIObservationItemForm;
